import { StoreCommonService } from './../../../../services/store/store-common.service';
/// <reference path="../../../../../../node_modules/@angular/core/src/metadata/directives.d.ts"/>
import {Component, OnInit, OnChanges, Input, SimpleChanges} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import 'rxjs/Rx';
import {StoreModel} from '../../../../models/store-common.model';
import {KoncentroValidators} from '../../../../modules/UIKit/validators/koncentro-validators';
import {StoreConfigurationService} from '../../../../services/store-configuration/store-configuration.service';

@Component({
  selector: 'app-kv-store-common-link',
  templateUrl: './store-common-link.component.html',
  styleUrls: ['./store-common-link.component.css'],
  providers: []
})
export class StoreCommonLinkComponent implements OnInit, OnChanges {

  @Input() editMode: boolean;
  @Input() storeId: number;

  formLink: FormGroup;

  fields: any;
  invalidSubmit: boolean;

  validationData = null;

  private divisionSalesNetworkId: number = null;

  linkInfo: { [key: string]: string } = {
    front_end: '-',
    promotion: '-',
    customer: '-',
    loyalty: '-',
    analytics: '-',
    backoffice: '-',
    couponing: '-'
  };

  constructor(
    private fb: FormBuilder,
    private srvStore: StoreCommonService,
    private srvStoreConfiguration: StoreConfigurationService
  ) {}

  ngOnInit(): void {
    this.loadValidation();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['storeId'] && !changes['storeId'].firstChange) {
      this.loadActiveConfigLinks();
    }
  }

  loadValidation() {
    this.srvStore.getFields().subscribe(res => {
      this.fields = res
    });
  }

  private formatCodeDescription(code: string, description: string): string {
    const parts = [code, description].filter(v => !!v);
    return parts.length > 0 ? parts.join(' - ') : '-';
  }

  private resetLinkInfo() {
    Object.keys(this.linkInfo).forEach(key => { this.linkInfo[key] = '-'; });
  }

  private applyConfig(config: any) {
    this.linkInfo.front_end = this.formatCodeDescription(config.front_end_code, config.front_end_description);
    this.linkInfo.promotion = this.formatCodeDescription(config.promotion_code, config.promotion_description);
    this.linkInfo.customer = this.formatCodeDescription(config.customer_code, config.customer_description);
    this.linkInfo.loyalty = this.formatCodeDescription(config.loyalty_code, config.loyalty_description);
    this.linkInfo.analytics = this.formatCodeDescription(config.analytics_code, config.analytics_description);
    this.linkInfo.backoffice = this.formatCodeDescription(config.backoffice_code, config.backoffice_description);
    this.linkInfo.couponing = this.formatCodeDescription(config.couponing_code, config.couponing_description);
  }

  private fetchActiveConfig(searchKey: string, searchValue: any) {
    return this.srvStoreConfiguration.list(null, null, [
      { key: 'validity_status', value: 'active' },
      { key: searchKey, value: String(searchValue) }
    ]).map(res => {
      const data = (res && res.data) || [];
      return Array.isArray(data) ? data[0] : data;
    });
  }

  loadActiveConfigLinks() {
    this.resetLinkInfo();
    if (!this.storeId) {
      return;
    }
    // 1. cerca una configurazione attiva specifica per lo store selezionato
    this.fetchActiveConfig('store_id', this.storeId).subscribe(config => {
      if (config) {
        this.applyConfig(config);
        return;
      }
      // 2. se non trovata, ricade sulla configurazione attiva della division_sales_network dello store
      if (!this.divisionSalesNetworkId) {
        return;
      }
      this.fetchActiveConfig('division_sales_network_id', this.divisionSalesNetworkId).subscribe(divisionConfig => {
        if (divisionConfig) {
          this.applyConfig(divisionConfig);
        }
      });
    });
  }

  createForm(res: StoreModel) {
    this.divisionSalesNetworkId = res.division_sales_network_id || null;

    this.formLink = this.fb.group({
      flg_graphical_printer: [res.flg_graphical_printer || false],
      flg_campaign_candidate: [res.flg_campaign_candidate || false],
      ip_address: [res.ip_address || null, KoncentroValidators.ipAddress],
      ext_flyer_url: [res.ext_flyer_url || null]
    });

    this.loadActiveConfigLinks();
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-common-link/store-common-link.component.ts